module.exports = __webpack_public_path__ + "campng.png?23092a933728540c8610677413e525bd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/campng.png
// module id = 52
// module chunks = 0